// AdForm
export const ADFORM_PUSH = "ADFORM_PUSH";
export const ADFORM_PUSH_FAILED = "ADFORM_PUSH_FAILED";
export const ADFORM_PUSH_SUCCESS = "ADFORM_PUSH_SUCCESS";

// Google Ads
export const GOOGLE_ADS_PUSH = "GOOGLE_ADS_PUSH";
export const GOOGLE_ADS_PUSH_FAILED = "GOOGLE_ADS_PUSH_FAILED";
export const GOOGLE_ADS_PUSH_SUCCESS = "GOOGLE_ADS_PUSH_SUCCESS";

// Ttd
export const TTD_PUSH = "TTD_PUSH";
export const TTD_PUSH_FAILED = "TTD_PUSH_FAILED";
export const TTD_PUSH_SUCCESS = "TTD_PUSH_SUCCESS";
export const TTD_CLEAR_ERROR_STATE = "TTD_CLEAR_ERROR_STATE";

// Xandr
export const XANDR_PUSH = "XANDR_PUSH";
export const XANDR_PUSH_SUCCESS = "XANDR_PUSH_SUCCESS";
export const XANDR_PUSH_FAILED = "XANDR_PUSH_FAILED";
